import _toConsumableArray from "/Users/scrogson/github/scrogson/soundworks-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { isFileList, isObject, isUploadFile } from './validators';

var extractFiles = function extractFiles(variables) {
  var files = [];

  var walkTree = function walkTree(tree) {
    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var mapped = Array.isArray(tree) ? tree : Object.assign({}, tree);
    Object.keys(mapped).forEach(function (key) {
      var value = mapped[key];

      var name = _toConsumableArray(path).concat([key]).join('.');

      if (isUploadFile(value) || isFileList(value)) {
        var file = isFileList(value) ? Array.prototype.slice.call(value) : value;
        files.push({
          file: file,
          name: name
        });
        mapped[key] = name;
      } else if (isObject(value)) {
        mapped[key] = walkTree(value, name);
      }
    });
    return mapped;
  };

  return {
    files: files,
    variables: walkTree(variables)
  };
};

export default extractFiles;